import {VuexModule, Module, Mutation, Action, getModule} from 'vuex-module-decorators';
import Store from '@/store';
import {ITopic} from '@/models/document';
import ITodoCollection from '@/models/todoCollection';
import {Vue, Component} from 'vue-property-decorator';
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';
import {Loading} from 'quasar';


@Module({namespaced: true, name: 'HomeViewModule', dynamic: true, store: Store})
class HomeViewModule extends VuexModule {
    public featureDialogActive: boolean = false;
    public documentId: string = '';
    public documentName: string = '';
    public documentTopic: string = '';
    public documentTopics: string[] = [];
    public documentSearchTopics: string[] = [];
    public documents: ITodoCollection[] = [];
    public filteredDocuments: ITodoCollection[] = [];
    public promptAddDocumentDialog: boolean = false;
    public promptWhyDocumentDialog: boolean = false;

    @Mutation
    public setDocuments(documents: ITodoCollection[]) {
        this.documents = documents;
    }

    @Mutation
    public setFilteredDocuments(filtereDocuments: ITodoCollection[]) {
        this.filteredDocuments = filtereDocuments;
    }

    @Mutation
    public setPromptAddDocumentDialog(promptAddDocumentDialog: boolean) {
        this.promptAddDocumentDialog = promptAddDocumentDialog;
    }

    @Mutation
    public setPromptWhyDocumentDialog(promptWhyDocumentDialog: boolean) {
        this.promptWhyDocumentDialog = promptWhyDocumentDialog;
    }

    @Mutation
    public setDocumentTopic(documentTopic: string) {
        this.documentTopic = documentTopic;
    }

    @Mutation
    public setDocumentTopics(documentTopics: string[]) {
        this.documentTopics = documentTopics;
    }

    @Mutation
    public setDocumentSearchTopics(documentSearchTopics: string[]) {
        this.documentSearchTopics = documentSearchTopics;
    }

    @Action
    public async loadDocuments(user: any | undefined) {
        console.log(user);
        let todoDataService = new TodoDataServicesCollection();
        Loading.show();
        await todoDataService.GetAll().then(async (listData:any) => {
            this.setDocuments(listData);
            this.setDocumentTopics([
                ...new Set(this.documents.map((document) => {
                    if ((document.userId === (user && user.data ? user.data.uid : '')) || document.userId === undefined) {
                        return document.topic;
                    } else {
                        return '';
                    }
                }).filter((document) => document != ''))
            ]);
            this.setDocumentSearchTopics([
                ...new Set(this.documents.map((document) => {
                    if ((document.userId === (user && user.data ? user.data.uid : '')) || document.userId === undefined) {
                        return document.topic;
                    } else {
                        return '';
                    }
                }).filter((document) => document != '')), 
                ...new Set(this.documents.map((document) => {
                    if ((document.userId === (user && user.data ? user.data.uid : '')) || document.userId === undefined) {
                        return document.subject;
                    } else {
                        return '';
                    }
                }).filter((document) => document != '')),
            ]);
        });
        Loading.hide();

    }

    @Action
    public async loadTopicFilter(topicFilter: string) {
        this.setDocumentTopic(topicFilter);
        this.setFilteredDocuments(this.documents.filter((document) => 
            (document.topic === topicFilter) || 
            (document.subject === topicFilter)
        ));
    }

    @Action
    public async clearTopicFilter() {
        this.setDocumentTopic('');
        this.setFilteredDocuments(this.documents);
    }

    @Action
    public loadPromptAddDocumentDialog(promptAddDocumentDialog: boolean) {
        this.setPromptAddDocumentDialog(promptAddDocumentDialog);
    }

    @Action
    public loadPromptWhyDocumentDialog(promptWhyDocumentDialog: boolean) {
        this.setPromptWhyDocumentDialog(promptWhyDocumentDialog);
    }

}

export default getModule(HomeViewModule);
